import React from 'react';

function MobilePhoneCheck(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M16.7283 5.0458C16.4521 4.83872 16.0604 4.89472 15.8533 5.17087L13.4325 8.39921L12.1819 7.14972L12.0954 7.07741C11.8518 6.90866 11.515 6.93277 11.2981 7.14972C11.054 7.3938 11.054 7.78953 11.2981 8.03361L12.6035 9.33627L12.6713 9.39168C13.2325 9.81268 14.0161 9.70213 14.4318 9.15013L16.8534 5.92079L16.9076 5.83478C17.047 5.56813 16.9768 5.23218 16.7283 5.0458Z" />
      <path
        clipRule="evenodd"
        d="M8.5 7C8.5 3.89316 11.0182 1.375 14.125 1.375C17.2318 1.375 19.75 3.89316 19.75 7C19.75 10.1068 17.2318 12.625 14.125 12.625C11.0182 12.625 8.5 10.1068 8.5 7ZM18.5 7C18.5 4.58351 16.5415 2.625 14.125 2.625C11.7085 2.625 9.75 4.58351 9.75 7C9.75 9.41649 11.7085 11.375 14.125 11.375C16.5415 11.375 18.5 9.41649 18.5 7Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M8.375 3.875C8.375 3.52982 8.09518 3.25 7.75 3.25H6.2775L6.10699 3.25493C4.58364 3.34323 3.375 4.60706 3.375 6.1525V19.0992L3.38004 19.2697C3.46926 20.7935 4.73261 22.001 6.27791 22H11.7233L11.8938 21.9951C13.4171 21.9068 14.625 20.6438 14.625 19.0983V14.5L14.6182 14.4076C14.5736 14.1063 14.3138 13.875 14 13.875C13.6548 13.875 13.375 14.1548 13.375 14.5V17H4.625V6.1525L4.63107 6.00996C4.70339 5.16431 5.41319 4.5 6.2775 4.5H7.75L7.84236 4.49322C8.14374 4.44858 8.375 4.1888 8.375 3.875ZM4.625 18.25V19.0983L4.63115 19.2413C4.69965 20.0374 5.33192 20.6719 6.12668 20.7433L6.2775 20.75H11.7232L11.8659 20.7439C12.6617 20.6759 13.2963 20.0439 13.3682 19.2491L13.375 19.0983V18.25H4.625Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default MobilePhoneCheck;
